import {PageInfo} from "modules/models/PageInfo";
import {UserInfo} from "modules/models/UserInfo";
import getUserInfo from "modules/utilities/getUserInfo";
import {cookieService} from "modules/services/CookieService";
import * as _ from "lodash";

declare var initStore: any;
const env: any = initStore.env;
declare const CRUserInfo: any;

declare var s_gi, dataLayer;
declare var window;

/** Each page can set a global variable to exclude itself from the referrerlist **/
if (!initStore.referrerExclude) {
    // console.log("Excluding page from referrer list");
    document.cookie = "userReferrer=" + encodeURIComponent(document.location.href) + ";domain=" + document.domain.split(".").slice(-2).join(".") + ";path=/";
}

/* c-reidho: DRS-129 */
/**
 * Site Catalyst performance analytics
 * @returns {Number}
 */
function s_getLoadTime() {
    "use strict";
    var s_loadT2 = window.s_loadT2;
    if (!s_loadT2) {
        var
            b = new Date().getTime(),
            o = window.performance ? performance.timing : 0,
            a = o ? o["requestStart"] : window.inHeadTS || 0;          // ToDo where is inHeadTS defined? (Adobe Analytics)
        s_loadT2 = a ? Math.round((b - a) / 100) : "";
    }
    return s_loadT2;
}

const onCRUserInfoReady = function (doSiteCatalystProperties){
    if(typeof CRUserInfo != 'undefined' && typeof CRUserInfo.ready === 'function' ){
        CRUserInfo.ready().then( doSiteCatalystProperties )
    } else {
        $(document).on('userInfo_ready', doSiteCatalystProperties )
    }
};

export class AnalyticsTrackingService {
    pageInfo: PageInfo;
    userInfo: UserInfo;
    scSuiteName: string;

    constructor(pageInfo: PageInfo, userInfo: UserInfo) {
        this.scSuiteName = env.SITE_CATALYST;
        this.pageInfo = pageInfo;
        this.userInfo = userInfo;
    }

    initialize() {
        if (this.pageInfo.trackOnLoad) { //No onload tracking for Compare page
            onCRUserInfoReady(()=> {
                var s = s_gi(this.scSuiteName);
                s = this.getSiteCatalystPageLoad(s);
                let $this = this;
                /************* DO NOT ALTER ANYTHING BELOW THIS LINE ! **************/
                var s_code = s.t();
                if (s_code) document.write(s_code);//-->

                //End do not alter block
                $("body").on("click","[data-tracking]", function(){
                    let data: any = $(this).data();
                    data.linkName = data.tracking;
                    $this.siteCatalystEvent(data);
                });

                $("body").on("cro.analytics", function(event, data) {
                    $this.siteCatalystEvent( data );
                });

                $("body").on("cro.analytics_change_section", function (event, data) {
                    $this.siteCatalystSectionEvent( data );
                });

                $("body").on("cro.tabsetChange", function(event, data) {
                    var s = s_gi($this.scSuiteName);
                    $.extend($this.pageInfo.siteCatalystPageProperties, data.siteCatalyst, {pageName: null});
                    s = $this.getSiteCatalystDefaultProperties(s);
                    $this.pageInfo.siteCatalystPageProperties.pageName = s.pageName =  "CRO:" + s.prop1 + ":" + s.prop2 + ":" + s.prop3 + ":" + s.prop4 + ":" + s.prop5;
                    let currDataLayer = (dataLayer) ? dataLayer[0] : {};
                    $.extend(currDataLayer, data.gtm);

                    dataLayer.push([currDataLayer]);
                    return setTimeout(()=> {
                        s.t();
                    }, 1);
                });
            });
        }
    }

    /**
     *
     * @param {object} s
     * @returns {object} s
     */
    getSiteCatalystPageLoad(s) {
        s = this.getSiteCatalystDefaultProperties(s);
        if (s.prop1 && s.prop2 && s.prop3 && s.prop4 && !this.pageInfo.siteCatalystPageProperties.pageName) {
            this.pageInfo.siteCatalystPageProperties.pageName = s.pageName = "CRO:" + s.prop1 + ":" + s.prop2 + ":" + s.prop3 + ":" + s.prop4;
        }
        return s;
    }


    gtmPageEvent(event, type, arg1) {
        //todo: see resources/assets/js/seoscripts.js and figure out extra data required
    }


    private getMemberType(): string {
        if (typeof CRUserInfo != "undefined" && typeof CRUserInfo.TIER_NAMES != "undefined") {
            return CRUserInfo.hasAtLeastMembershipTier(CRUserInfo.TIER_NAMES.DIGITAL) ? "subscriber" : "visitor";
        } else {
            return "visitor";
        }
    }

    /**
     *
     * @param {object} s
     * @returns {object} s
     */
    getSiteCatalystDefaultProperties(s) {
        var val;
        for (val in this.pageInfo.siteCatalystPageProperties) {
            s[val] = this.pageInfo.siteCatalystPageProperties[val];
        }

        s.prop16 = this.getMemberType();
        s.linkInternalFilters += ",www.cars.com";

        if (typeof CRUserInfo != "undefined") {
            if (typeof CRUserInfo.getTier === "function") {
                var tier = CRUserInfo.getTier();
                if (tier) {
                    s.prop27 = s.eVar80 = tier.toLowerCase();
                    s.linkTrackVars += ",prop27,eVar80";
                }
            }
            if (typeof CRUserInfo.subscriptionsOwned === "function") {
                var subscriptionsOwned = CRUserInfo.subscriptionsOwned();
                if (subscriptionsOwned) {
                    s.prop28 = s.eVar86 = subscriptionsOwned;
                    s.linkTrackVars += ",prop28,eVar86";
                }
            }
        }

        s.eVar58 = s.prop58 = this.pageInfo.getLayout();

        if (cookieService.get("siteCatalystLoginSuccess")) {
            s.events = "event13";
            cookieService.put("siteCatalystLoginSuccess", null, {
                expires: -1,
                path: "/",
                domain: this.pageInfo.domain
            });
        }

        /* c-reidho: DRS-129 */
        if (s_getLoadTime()) {
            //s.events = s.apl(s.events, 'event45=' + s_getLoadTime(), ',', 1);
        }
        return s;
    }

    siteCatalystEvent(data) {

        data = $.extend({linkName: ""}, data || {});
        var s = s_gi(this.scSuiteName);
        var override: any = {};
        override.linkTrackVars = "prop48,eVar48,prop72,eVar72,prop58,eVar58,eVar7,eVar26";

        override.prop48 = override.eVar48 = s.pageName + " | " + data["linkName"].toLowerCase().replace(/ /g, "_");

        if (data["linklocation"]) {
            override.prop48 = override.eVar48 = override.prop48 + "-" + data["linklocation"];
        }

        if (data["filter"]) {
            override.prop71 = override.eVar71 = data["filter"];
            override.linkTrackVars += ",prop71,eVar71"
        }

        if (data.evar7) {
            override.eVar7 = data.evar7;
        }

        if (data.evar26) {
            override.eVar26 = data.evar26;
        }

        if (data.events) {
            override.linkTrackEvents = override.events = data.events;
        }

        override.prop72 = override.eVar72 = this.pageInfo.siteCatalystPageProperties.prop72 || "";
        override.prop58 = override.eVar58 = this.pageInfo.getLayout() || "";

        return setTimeout(function () {
            s.tl(this, "o", data["linkName"], override);

        }, 1);
    }

    siteCatalystPageEvent(event, type, arg1) {
        "use strict";
        var s = s_gi(this.scSuiteName);
        if (type == "products" && event.currentTarget.dataset.path) {
            if (this.pageInfo.alternateProperties.prop4) this.pageInfo.siteCatalystPageProperties.prop4 = this.pageInfo.alternateProperties.prop4[event.currentTarget.dataset.path.replace(/\//g, "")]; //for model page
        } else if (type == "ratings" && arg1) {
            var tabValue = arg1;
            if (this.pageInfo.alternateProperties.prop3) this.pageInfo.siteCatalystPageProperties.prop3 = this.pageInfo.alternateProperties.prop3[tabValue]; //for ratings page
        } else if (type == "compare" && arg1) {
            var products = arg1;
            s.products = products.toString();
        }
        s = this.getSiteCatalystPageLoad(s);
        this.gtmPageEvent(event, type, arg1); // track changes into google tag manager
        return setTimeout(() => {
            s.t();

        }, 1);
    }

    siteCatalystSectionEvent(section) {
        "use strict";
        var s = s_gi(this.scSuiteName);

        this.pageInfo.siteCatalystPageProperties.prop4 = section;
        this.pageInfo.siteCatalystPageProperties.pageName = null;

        s = this.getSiteCatalystPageLoad(s);
        return setTimeout(() => {
            s.t();

        }, 1);
    }

    siteCatalystVirtualPageEvent(scProps) {
        let s = s_gi(this.scSuiteName);
        s = this.getSiteCatalystDefaultProperties(s);

        if (s.prop72) {
            s.eVar72 = s.prop72;
        }

        if (scProps.pageName) {
            s.pageName = scProps.pageName;
        }

        s.t(scProps);
    }


    siteCatalystLinkClickEvent(linkName, linkLocation) {
        var s = s_gi(this.scSuiteName);
        var override: any = {};
        override.linkTrackVars = "prop48,eVar48,prop72,eVar72";

        if (typeof linkName === "undefined") {
            linkName = "";
        }
        override.prop48 = override.eVar48 = s.pageName + " | " + linkName.toLowerCase().replace(/ /g, "_");
        if (linkLocation)
            override.prop48 = override.eVar48 = override.prop48 + "-" + linkLocation + "_nav";
        override.prop72 = override.eVar72 = this.pageInfo.siteCatalystPageProperties.prop72 || "";
        return setTimeout(function () {
            s.tl(this, "o", linkName.replace(/ /g, "_"), override);

        }, 1);
    }

    gtmVirtualPageEvent(gtmLayer = {}) {
        if (_.isArray(dataLayer)) {
            const initialLayer = dataLayer[0] || {};
            dataLayer.push({
                "event": "gtm.load",
                ...initialLayer,
                ...gtmLayer
            });
        }
    }
}



// WEBPACK FOOTER //
// ./resources/modules/services/AnalyticsTrackingService.ts